export default "__VITE_ASSET__f17a7337__"